import { ThemeProvider } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectThemeObject } from 'redux/app/theme/theme.selectors';

const Theme = ({ children }) => {
  const theme = useSelector(selectThemeObject);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default Theme;
